
export default function QuickActions() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const actions = [
    {
      title: 'Voir les Leads',
      description: 'Parcourez les demandes clients disponibles',
      icon: 'ri-search-line',
      color: 'bg-orange-600',
      textColor: 'text-orange-600',
      bgColor: 'bg-orange-50',
      action: () => scrollToSection('leads')
    },
    {
      title: 'Alertes WhatsApp',
      description: 'Recevez les nouveaux leads en temps réel',
      icon: 'ri-whatsapp-line',
      color: 'bg-green-600',
      textColor: 'text-green-600',
      bgColor: 'bg-green-50',
      action: () => scrollToSection('whatsapp-alerts')
    },
    {
      title: 'Nous Contacter',
      description: 'Une question ? Parlons ensemble',
      icon: 'ri-customer-service-line',
      color: 'bg-blue-600',
      textColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
      action: () => scrollToSection('contact')
    }
  ];

  return (
    <section className="py-8 bg-white md:hidden">
      <div className="max-w-7xl mx-auto px-4">
        <h2 className="text-xl font-bold text-gray-900 mb-6 text-center">Actions Rapides</h2>
        
        <div className="grid grid-cols-1 gap-4">
          {actions.map((action, index) => (
            <button
              key={index}
              onClick={action.action}
              className={`${action.bgColor} p-4 rounded-2xl border border-gray-100 hover:shadow-lg transition-all transform hover:scale-105 cursor-pointer text-left group`}
            >
              <div className="flex items-center gap-4">
                <div className={`w-12 h-12 ${action.color} rounded-xl flex items-center justify-center group-hover:rotate-12 transition-transform`}>
                  <i className={`${action.icon} text-xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className={`font-semibold ${action.textColor} mb-1`}>{action.title}</h3>
                  <p className="text-sm text-gray-600">{action.description}</p>
                </div>
                <div>
                  <i className="ri-arrow-right-line text-gray-400 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
